import { RECORDS_RECEIVE_RECORDS, RECORDS_CREATE_RECORD, RECORDS_SHOW_SAVE_RESULT, RECORDS_EDIT_RECORD } from './actions'

const initialState = {
    availableRecords: [],
    selectedRecord: null,
    saveResult: null
};

export default function(record=initialState, action) {
    switch(action.type) {
        case RECORDS_RECEIVE_RECORDS:
            return {
                ...record,
                availableRecords: action.availableRecords
            };
        case RECORDS_CREATE_RECORD:
            return {
                ...record,
                selectedRecord: action.selectedRecord
            };
        case RECORDS_SHOW_SAVE_RESULT:
            return {
                ...record,
                saveResult: action.saveResult
            }
        case RECORDS_EDIT_RECORD:
            return {
                ...record,
                selectedRecord: action.selectedRecord
            }
        default:
            return record
    }
}